(() => {
  const STORAGE_KEY = 'soundhousCompareV1';

  const parseRegistry = (root) => {
    const node = root?.querySelector('[data-shcmp-registry]');
    if (!node) return [];
    try {
      const parsed = JSON.parse(node.textContent || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  const loadSelection = () => {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  const currentFamilyForHandle = (root, handle) => {
    const product = parseRegistry(root).find((item) => String(item?.handle || '').toLowerCase() === String(handle || '').toLowerCase());
    return product?.profile?.family || null;
  };

  const clearIfForeignFamily = (root) => {
    if (!root) return;

    const registry = parseRegistry(root);
    const visibleFamilies = new Set(registry.map((item) => item?.profile?.family).filter(Boolean));
    if (visibleFamilies.size === 0) return;

    const selection = loadSelection().filter((item) => item?.profile?.family);
    if (selection.length === 0) return;

    const selectedFamily = selection[0]?.profile?.family;
    if (!selectedFamily || visibleFamilies.has(selectedFamily)) return;

    root.querySelector('[data-shcmp-clear]')?.click();
  };

  const init = () => {
    document.querySelectorAll('[data-soundhous-compare-root]').forEach(clearIfForeignFamily);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('.shcmp-add[data-shcmp-handle]');
    if (!button) return;

    const root = document.querySelector('[data-soundhous-compare-root]');
    if (!root) return;

    const incomingFamily = currentFamilyForHandle(root, button.dataset.shcmpHandle);
    const selection = loadSelection().filter((item) => item?.profile?.family);
    const selectedFamily = selection[0]?.profile?.family || null;

    if (incomingFamily && selectedFamily && incomingFamily !== selectedFamily) {
      root.querySelector('[data-shcmp-clear]')?.click();
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
